export const getNonEmptyString = (value: string | undefined | null, replacementValue: string | undefined) =>
  value?.trim().length ? value : replacementValue;
